module.exports = __webpack_public_path__ + "static/media/mag1.03d54c18.jpeg";